<template>
    <div>
      <div class="results-tabs" v-if="!isMobile">
        <template v-if="showRouter">
            <template v-for="(val, page) in resultsAvailable">
                <router-link
                :key="page"
                :class="(activePage(page) ? 'is-selected' : '')"
                v-if="val"
                :to="getPageUrl(page)">
                    <label>
                        {{$t(page.toUpperCase() + '_BETTINGRESULTSPAGE')}}
                    </label>
                </router-link>
            </template>
        </template>
      </div>
      <vue-scroll :settings="{wheelPropagation:true}" class="offer-menu offer-menu-results" v-else>
        <div class="offer-menu-item calendar-menu-item" v-on:click="toggleCalendar" :class="{'is-selected': showCalendar}">
          <div class="sportsicon-calendar"></div>
          <p>{{$t('CALENDAR')}}</p>
        </div>
        <template v-if="showRouter">
            <template v-for="(val, page) in resultsAvailable">
                <router-link class="offer-menu-item" :key="page" v-if="val" :class="(activePage(page) ? 'active' : '')" :to="getPageUrl(page)">
                    {{$t(page.toUpperCase() + '_BETTINGRESULTSPAGE')}}
                </router-link>
            </template>
        </template>
    </vue-scroll>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
    name: 'ResultsPageRoutes',
    props: ['showCalendar'],
    methods:
    {
        getPageUrl(page)
        {
            const me = this;

            let url = `${me.websiteBaseUrl}/results/`;

            switch (page)
            {
            case 'prematch':
            case 'live':
                url += 'sport/prematch';
                break;
            case 'lotto':
                if (me.getClientName === 'admiral')
                {
                    url = `${me.websiteBaseUrl}/lotto-results/`;
                }
                else
                {
                    url += `${page}/`;
                }

                break;
            case 'horses':
                if (me.getClientName === 'admiral')
                {
                    url = `${me.websiteBaseUrl}/results/horses`;
                }
                else
                {
                    url += `${page}/`;
                }

                break;
            default:
                url += `${page}/`;
            }

            return url;
        },
        toggleCalendar()
        {
            const me = this;

            me.$emit('toggleCalendar');
        },
        activePage(subpage)
        {
            const me = this;

            return me.$route.name !== undefined && subpage === me.$route.name;
        },
    },
    watch:
    {

    },
    computed:
    {
        ...mapGetters([
            'isMobile',
            'resultsAvailable',
            'globals',
        ]),
        showRouter()
        {
            const me = this;

            if (!me.globals
            || !me.globals.publicConfig
            || !me.globals.publicConfig.website
            || me.globals.publicConfig.website.routerOptions == null
            || me.globals.publicConfig.website.routerOptions.displayResultsRouter == null
            || me.globals.publicConfig.website.routerOptions.displayResultsRouter === false)
            {
                return false;
            }

            let count = 0;

            for (const page in me.resultsAvailable)
            {
                if (me.resultsAvailable[page])
                {
                    count += 1;
                }
            }

            return (count > 1);
        },
        getClientName()
        {
            // eslint-disable-next-line no-undef
            return CLIENT_NAME;
        },
        websiteBaseUrl()
        {
            const me = this;

            if (me.getClientName === 'admiral')
            {
                return '/lotto';
            }

            return '/web';
        },
    },
};
</script>
